module.exports = __webpack_public_path__ + "static/img/home_bg2.f44b1f54.jpg";